import _regenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
import { login as _login, logout, getInfo, getCurrentUserInfo } from '@/api/user';
import { getToken, setToken, removeToken, getHywRole, setHywRole, removeHywRole, getRoleView, setRoleView, removeRoleView, setUserData, removeUserData } from '@/utils/auth';
import store from '@/store';
import router, { resetRouter } from '@/router';
var state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: '',
  hywRoles: getHywRole(),
  rolesViews: getRoleView(),
  userData: {}
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_ROLESVIEW: function SET_ROLESVIEW(state, rolesViews) {
    state.rolesViews = rolesViews;
  },
  SET_USERDATA: function SET_USERDATA(state, userData) {
    state.userData = userData;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var account = userInfo.account,
      password = userInfo.password,
      uid = userInfo.uid,
      code = userInfo.code;
    return new Promise(function (resolve, reject) {
      _login({
        account: account,
        password: password,
        uid: uid,
        code: code
      }).then(function (response) {
        if (!response.data.success) {
          reject(response.data.message);
        }
        var data = response.data.data;
        // commit('SET_ROLES', data.user.roles) // 注释该行，让permission.js在登陆的时候执行路由生成方法
        commit('SET_ROLESVIEW', data.rolesView || []);
        commit('SET_TOKEN', data.token);
        commit('SET_NAME', data.name);
        commit('SET_AVATAR', data.avatar);
        commit('SET_INTRODUCTION', data.introduction);
        commit('SET_USERDATA', data);
        setToken(data.token);
        setRoleView(data.rolesView || []);
        setHywRole(data.roles || []);
        setUserData(data || {});
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    return new Promise(function (resolve, reject) {
      getCurrentUserInfo().then(function (rep) {
        if (rep.data.success) {
          var roles = (rep.data.data['roles'] || []).length === 0 ? ['editor'] : rep.data.data['roles'];
          var views = rep.data.data['rolesView'] || [];
          // const views = ['hospital', 'hospitalList', 'hospitalCreate', 'hospitalEdit',
          // 'hospitalLevelList', 'roles', 'rolesList', 'rolesApiList', 'adminSetting', 'AdminSettingUser']
          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject('getInfo: roles must be a non-null array!');
          }
          commit('SET_USERDATA', rep.data.data);
          commit('SET_ROLES', roles);
          resolve({
            roles: roles,
            views: views
          });
        } else {
          store.dispatch('user/resetToken').then(function () {
            location.reload();
          });
        }
      });
    });
  },
  // user logout
  logout: function logout(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state,
      dispatch = _ref3.dispatch;
    return new Promise(function (resolve, reject) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_ROLESVIEW', []);
      removeHywRole();
      removeRoleView();
      removeToken();
      removeUserData();
      resetRouter();

      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      dispatch('tagsView/delAllViews', null, {
        root: true
      });
      resolve();
    });
  },
  // remove token
  resetToken: function resetToken(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_ROLESVIEW', []);
      removeHywRole();
      removeRoleView();
      removeToken();
      removeUserData();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref5, role) {
    var commit = _ref5.commit,
      dispatch = _ref5.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              setToken(token);
              _context.n = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context.v;
              roles = _yield$dispatch.roles;
              resetRouter();

              // generate accessible routes map based on roles
              _context.n = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context.v;
              // dynamically add accessible routes
              router.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};